import { RouterManager } from '@aclass/admin/managers';
import { EmailTemplateStory } from '@aclass/admin/storage/actions';
import { IAdminState, IEmailTemplateModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class EmailTemplateEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:email-template-edit';

    private id: number;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IEmailTemplateModuleState['editPageRecordId']>(['emailTemplateModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(EmailTemplateEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        this.id = parseInt(route.params.id);
        this.ngRdx.dispatch(EmailTemplateStory.dryRunEditPage({ id: this.id }));
    }
}
